import { AxiosResponse } from 'axios';
import { RegisterCertification } from 'shell/models/register-certification';
import { HttpResponseList } from 'shell/models/http-response';
import {
  RegisterCertificationResponse,
  RegisterCertificationClient,
} from 'front-office/view-models/register-certification-list';

export const transformRegisterCertificationList = (
  response: AxiosResponse<HttpResponseList<RegisterCertification>>
): RegisterCertificationResponse => {
  const data: Array<RegisterCertification> = response.data.payload?.list || [];

  const resList: Array<RegisterCertificationClient> = data.map(
    (register: RegisterCertification) => {
      return {
        initials: register.sigla || '',
        type: register.key?.codice || '',
        description: register.descrizione || '',
        institutionCode: register.key?.codiceEnte,
      };
    }
  );

  return {
    count: response.data.payload?.totalRows || 0,
    list: resList || [],
  } as RegisterCertificationResponse;
};
